export const ROL_TRATANTE = 'Tratante'